export default "__VITE_ASSET__cb6071c8__"